import angular from 'angular';
import angularRoute from 'angular-route';
import 'angular-click-outside';
import 'ng-infinite-scroll';
import Raven from 'raven-js';
import ngRaven from 'raven-js/plugins/angular';
import 'flatpickr/dist/flatpickr.min.css';

import browserConfig from '../../config/browser.config';

import root from './modules/root';
import common from './modules/common';
import user from './modules/user';
import users from './modules/users';
import brands from './modules/brands';

const appConfiguration = Object.assign({}, browserConfig, (global.appConfiguration || {}));
const featuresModules = [];

const { features: { sentry } } = appConfiguration;
if (sentry.enabled) {
  Raven
  .config(`https://${sentry.apiKey}@sentry.io/${sentry.projectId}`)
  .addPlugin(ngRaven, angular)
  .install();

  featuresModules.push(ngRaven.moduleName);
}

angular
.module('authNZUIApp', [
  ...featuresModules,
  angularRoute,
  'tw.directives.clickOutside',
  'infinite-scroll',
  root,
  common,
  user,
  users,
  brands,
])
.constant('appConfiguration', appConfiguration);
